import { Orders_Company_Products } from '@/__generated__/graphql';
import { CompanyProductType } from '@/constants/company';
import { TypedDocumentNode, gql } from '@apollo/client';

export type CompanyProduct = Orders_Company_Products & {
  product_type: CompanyProductType;
};

export type GetMerchantEnabledProductsQueryType = {
  orders_company_products: CompanyProduct[];
};

export type GetMerchantEnabledProductsQueryVariables = {
  companyId: number;
};
export const getMerchantEnabledProductsQuery = gql`
  query getMerchantEnabledProducts($companyId: bigint!){
    orders_company_products(where: { _and: { enabled: { _eq: true }, company_id: { _eq: $companyId } } }) {
      product_type
      enabled
    }
  }
` as TypedDocumentNode<
  GetMerchantEnabledProductsQueryType,
  GetMerchantEnabledProductsQueryVariables
>;
